// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
export function PlayerDescription({
  description: u
}) {
  const o = u?.trim().slice(0, 180),
    [m, r] = React.useState("");
  return React.useEffect(() => {
    if (!o) return;
    r("");
    let g = 0;
    const j = window.setInterval(() => {
      g += 1, r(o.slice(0, g)), g >= o.length && window.clearInterval(j);
    }, 16);
    return () => window.clearInterval(j);
  }, [o]), o ? jsxRuntime.jsx("section", {
    className: "mc-player-description",
    "aria-label": "Описание игрока",
    children: jsxRuntime.jsxs("p", {
      children: [jsxRuntime.jsx("i", {
        children: "“"
      }), m, jsxRuntime.jsx("b", {
        className: m.length === o.length ? "finished" : ""
      })]
    })
  }) : null;
}
